import "core-js/modules/es.error.cause.js";
import { win as t } from "@rei/browser-shim";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import d from "lodash/isPlainObject.js";
const u = (e, n = window.document.cookie) => {
  var r;
  return (r = n.split("; ").find((o) => o.startsWith(`${e}=`))) == null ? void 0 : r.split("=")[1];
}, f = () => u("rrUserId") || "", C = async () => {
  try {
    return await t.metrics.getVisitorId();
  } catch {
    return "";
  }
}, w = async () => {
  const e = await C();
  e.length && t.R3_COMMON.setSessionId(e);
}, _ = () => {
  const e = t.location.host.split(".")[0];
  e === "corp" || e === "www" ? t.R3_COMMON.setBaseUrl("//recs.richrelevance.com/rrserver/") : t.R3_COMMON.setBaseUrl("//integration.richrelevance.com/rrserver/");
}, h = async () => {
  if (typeof t.r3_common > "u")
    throw new Error("cannot find r3_common on global scope as required for Rich Relevance, may be missing p13n.js");
  t.R3_COMMON = new t.r3_common(), t.R3_COMMON.setApiKey("30280c406d639577"), _(), t.R3_COMMON.setClickthruServer(`${t.location.protocol}//${t.location.host}`);
  const e = f();
  e !== "" ? (t.R3_COMMON.setUserId(e), t.R3_COMMON.addSegment("member", "member")) : t.R3_COMMON.addSegment("non-member", "non-member"), await w();
}, l = (e) => typeof e == "function", R = (e) => {
  window && (window.location.href = e);
}, p = () => {
  var e, n, r;
  return (r = (n = (e = window == null ? void 0 : window.RR) == null ? void 0 : e.data) == null ? void 0 : n.JSON) == null ? void 0 : r.placements;
}, x = (e) => {
  const n = p(), r = structuredClone(n);
  return n ? r.filter((o) => e === o.placementName)[0] : (console.warn("could not get placements from RR.data.JSON"), null);
}, O = (e) => fetch(e, {
  mode: "cors"
}).then((n) => (n.status !== 200 && console.warn(`Rich Relevance Server click returning status code ${n.status}, url: ${e}`), n)).catch((n) => (console.warn(`Rich Relevance Server click is failing with error: ${n}, url: ${e}`), n)), g = (e, n) => new Promise((r) => {
  l(e) && d(n) ? e(n) : (l(e) || console.warn("analyticsClickHandler must be a function"), d(n) || console.warn("analyticsConfig must be an object")), r();
}), H = (e) => (n) => {
  if (!window)
    return;
  const {
    event: r,
    rrClickUrl: o,
    analyticsConfig: s,
    redirectHref: a
  } = n;
  if (!a) {
    console.warn("no href provided for redirect!");
    return;
  }
  r.preventDefault(), Promise.all([O(o), g(e, s)]).then(() => {
    R(a);
  }).catch((c) => {
    console.warn(`failure in handleRRClick, error: ${c}`), R(a);
  });
}, M = () => {
  if (!window)
    return;
  const e = window.document.createEvent("Event");
  e.initEvent("rr-json-data-loaded", !0, !0), window.document.dispatchEvent(e);
}, E = (e) => {
  window && (window.RR.jsonCallback = e || M);
}, I = () => {
  t.rr_flush_onload(), t.r3();
}, A = () => {
  ["R3_ITEM", "R3_SEARCH", "R3_CATEGORY"].forEach((e) => {
    e in t && delete t[e];
  }), t.R3_COMMON.placementTypes = "";
}, N = (e) => {
  if (!e || typeof e != "function")
    throw new Error("pageContextCB is required and should be a function");
}, y = (e = "") => {
  if (!Array.isArray(e) && e.length)
    throw new Error("If using placements, make sure it is passed in as an array");
}, B = async (e) => {
  const {
    pageContextCB: n,
    customFilters: r,
    rrCallback: o,
    placements: s,
    reset: a
  } = e;
  try {
    N(n), y(s), a || await h(), a && A(), n(), Array.isArray(r) && r.length && r.forEach((c) => {
      typeof c == "function" && c();
    }), s && s.forEach((c) => {
      t.R3_COMMON.addPlacementType(c);
    }), E(o), I();
  } catch (c) {
    console.error(`Error interacting with third party (RichRelevance). message: ${c.message}`);
  }
}, D = (e = "//satchel.rei.com/packages/rich-relevance/p13n.js") => new Promise((n, r) => {
  const o = t.document.createElement("script");
  o.onload = () => {
    n();
  }, o.onerror = (s) => {
    console.warn("script was not able to load via @rei/recommendations loadScript"), r(s);
  }, o.src = e, t.document.head.appendChild(o);
}), i = (e, n) => {
  !Array.isArray(e) || !e.length || typeof n == "function" && e.slice(0, 15).forEach((r) => n(r));
}, m = (e) => {
  t.R3_COMMON.addCategoryHintId(e);
}, $ = (e) => {
  e.forEach((n) => t.R3_COMMON.blockItemId(n));
}, P = (e) => {
  t.R3_COMMON.setPageBrand(e);
}, U = (e) => {
  e.forEach((n) => t.R3_COMMON.addFilterBrand(n)), t.R3_COMMON.setFilterBrandsIncludeMatchingElements("true");
}, q = (e, n, r) => {
  t.R3_ITEM = new t.r3_item(), t.R3_ITEM.setId(e), t.R3_ITEM.setName(n), r && m(r);
}, G = (e, n) => {
  t.R3_SEARCH = new t.r3_search(), t.R3_SEARCH.setTerms(e), i(n, (r) => t.R3_SEARCH.addItemId(r));
}, j = (e) => {
  t.R3_BRAND = new t.r3_brand(), P(e);
}, F = (e, n, r) => {
  t.R3_CATEGORY = new t.r3_category(), e && t.R3_CATEGORY.setId(e), n && t.R3_CATEGORY.setName(n), i(r, (o) => t.R3_COMMON.addItemId(o));
}, Y = (e, n) => {
  t.R3_ADDTOCART = new t.r3_addtocart(), t.R3_ADDTOCART.addItemIdToCart(e.substring(0, 6), e), n && m(n);
}, V = (e, n) => {
  if (t.R3_CART = new t.r3_cart(), !Number.isNaN(parseInt(n, 10))) {
    const r = parseInt(n.toString().replace(".", ""), 10);
    t.R3_COMMON.setCartValue(r);
  }
  i(e, (r) => t.R3_CART.addItemId(r.substring(0, 6), r));
}, J = (e, n) => {
  t.R3_PURCHASED = new t.r3_purchased(), t.R3_PURCHASED.setOrderNumber(e), Array.isArray(n) && n.length > 0 ? n.forEach((r) => {
    const {
      price: o,
      qty: s,
      sku: a
    } = r;
    if (o && s && a) {
      const c = a.substring(0, 6);
      t.R3_PURCHASED.addItemIdPriceQuantity(c, o, s, a);
    } else
      console.warn("item is missing one or more required properties: price, qty, sku");
  }) : console.warn("cartItems is required and must be an array");
}, W = () => {
  t.R3_HOME = new t.r3_home();
}, K = () => {
  t.R3_ERROR = new t.r3_error();
}, L = () => {
  t.R3_GENERIC = new t.r3_generic();
};
export {
  U as addBrandFilters,
  m as addCategoryHint,
  H as buildRRClickHandler,
  B as default,
  x as getPlacementData,
  C as getSessionId,
  f as getUserId,
  I as launchRecs,
  D as loadScript,
  M as recsDataLoadedEvent,
  A as resetRR,
  Y as setAddToCartPageContext,
  $ as setBlockedItems,
  j as setBrandPageContext,
  V as setCartPageContext,
  F as setCategoryPageContext,
  K as setErrorPageContext,
  L as setGenericPageContext,
  h as setGlobalContext,
  W as setHomePageContext,
  q as setItemPageContext,
  P as setPageBrand,
  J as setPurchasedPageContext,
  E as setRRCallback,
  G as setSearchPageContext
};
